import { locationConstants } from './locationConstants';
import {userConstants} from "../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  rowsPerPage: 10,
  page: 1,
  sortBy: "id",
  sortDirection: "desc",
  error: '',
  query: "",
  inProgress: true,
});

export function locations(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case locationConstants.LOCATION_LIST_REQUEST:
      return {
        ...state,
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        inProgress: true,
      };
    case locationConstants.LOCATION_LIST_SUCCESS: {
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.locations.rows ? action.locations.rows : [],
        total: action.locations.total ? action.locations.total : 0,
        inProgress: false,
      };
    }
    case locationConstants.LOCATION_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case locationConstants.LOCATION_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case locationConstants.LOCATION_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.query !== action.pagination.query
        || state.exactFields !== action.pagination.exactFields
        || state.exactValues !== action.pagination.exactValues
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        query: action.pagination.query,
        exactFields: action.pagination.exactFields,
        exactValues: action.pagination.exactValues,
        shouldReload
      };
    }

    case locationConstants.LOCATION_SAVE_REQUEST:
      return {
        ...state,
        requestSaveActive: true,
      }
    case locationConstants.LOCATION_SAVE_SUCCESS:
      if (action.isNew) {
        return {
          ...state,
          requestSaveActive: false,
          items: [...state.items, action.location]
        }
      }
      return {
        ...state,
        requestSaveActive: false,
        items: state.items.map(l => l.id === action.location.id ? action.location : l)
      }
    case locationConstants.LOCATION_SAVE_FAILURE:
      return {
        ...state,
        requestSaveActive: false,
        error: action.error,
      }

    default:
      return state
  }
}
